import { useMemo } from 'react';
import { useGetFinderVehicleOptionsQuery } from '../../../../api/queries/getFinderVehicleOptions';
import { useCompany } from '../../../../components/contexts/CompanyContextManager';

export type FinderVehicleOption = { id: string; name: string; identifier: string };

const useSelectedFinderVehicles = (finderVehicleSuiteId: string[]) => {
    const company = useCompany(true);

    const { data } = useGetFinderVehicleOptionsQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            filter: {
                companyId: company?.id,
            },
        },
        skip: !company?.availableModules.hasFinderVehicleManagementModules,
    });

    return useMemo<FinderVehicleOption[]>(() => {
        const finderVehicles = data?.list?.items || [];

        if (!finderVehicleSuiteId?.length || !finderVehicles?.length) {
            return [];
        }

        return finderVehicleSuiteId
            .map(variantSuiteId => {
                const vehicle = finderVehicles.find(
                    vehicle => vehicle !== undefined && vehicle.versioning.suiteId === variantSuiteId
                );

                if (vehicle) {
                    return {
                        id: vehicle.versioning.suiteId,
                        name: vehicle.name.defaultValue,
                        identifier: vehicle.listing.id,
                    };
                }

                return null;
            })
            .filter(Boolean);
    }, [data, finderVehicleSuiteId]);
};

export default useSelectedFinderVehicles;
